import { Route, Switch } from "wouter";
import "./index.css";
import { Home } from "./home";

export function App() {
    return (
        <Switch>
            <Route path="/" component={Home} />
        </Switch>
    );
}

export default App;
